import './Text.css';

import React, { useState } from 'react';
export function WetCloud() {
    const [tYTNZ_ZZagU] = useState('tYTNZ_ZZagU')
  return (
    <div class="body">
      <div class="row">



<iframe  allow="fullscreen *"
frameborder="0"
        title='Freedom School'
        
        src={`https://youtube.com/embed/${tYTNZ_ZZagU}?autoplay=0`}>
</iframe>
      
      </div>

      <div class="row" id="GalleryThree">
  <div class="column" >   
        <h2>
          Wet Cloud
          <br/>A guided meditation.
        </h2>
        <br/>

        Find a comfortable position to relax your body.
        <br/><br/>
        You have nowhere to be
        but here.
        <br/><br/>
        Relax
        the shoulders
        that carry you.
        <br/><br/>
        You can release 
        the muscles 
        in your face.
        <br/><br/>
        Let go of your legs 
        and your feet.
        <br/><br/>
        And let the floor beneath you
        hold them.
        <br/><br/>
        You may watch the simulation
        On the screen.
        <br/><br/>
        Or you may gently 
        Look up 
        with your eyes.
        <br/><br/>
        And let your eye lids
        close over them.
        <br/><br/><br/>
        [breathe]
        <br/><br/><br/>
        Imagine
        that you are next 
        to a gently 
        flowing
        river.
        <br/><br/>
        You have nowhere to be
        but here.
        <br/><br/>
        Leaves 
        float on top
        of the water.
        <br/><br/>
        And float
        far away.
        <br/><br/>
        Past your line
        of sight.
        <br/><br/><br/>
        [breathe]
        <br/><br/><br/>
        Whenever
        a thought
        enters your mind,
        <br/><br/>
        Place that thought
        on top of a leaf.  
        <br/><br/>
        And watch that thought
        <br/><br/>
        float 
        far away.
        <br/><br/>
        Beyond your line
        of sight.
        <br/><br/><br/>

        [Pause]


        <br/><br/><br/>
        When you take
        A deep breath...
        <br/><br/>
        You are not
        breathing into
        your lungs.
        
        <br/><br/><br/>
        [breathe]
                </div>
          <div class="column" >   


        Breathe in through your nose,
        <br/><br/>
        and expand your stomach
        <br/><br/>
        Into a large basin 
        for water to flow 
        into.
        <br/><br/><br/>
        Raise your chest,
        <br/><br/>
        and fill it with clouds.
        <br/><br/><br/>
        Remember,
        <br/><br/>
        you have nowhere to be
        <br/><br/>
        but here.
        <br/><br/><br/>
        [breathe out through your mouth]
        <br/><br/><br/>
        When you take
        a deep breath,
        <br/><br/>
        The mouth of the river
        circles the base of your neck.
        <br/><br/><br/>
        Hold your breath.
        <br/><br/>
        And feel
        the river
        flow down 
        your back.
        <br/><br/>
        Beneath your shoulder blades.
        <br/><br/>
        Along your spine.
        <br/><br/>
        Cooling down
        the muscles 
        in your back.
        <br/><br/>
        And pooling
        into your stomach.
        <br/><br/><br/>
        [breathe]
        <br/><br/><br/>
        When you breathe out,
        <br/><br/>
        Breathe out of your mouth.
        <br/><br/>
        Make the sound of a rushing river,
        <br/><br/>
        and allow the river
        to rush down your body.
        <br/><br/>
        Cooling Your thighs.
        <br/><br/>
        Cooling your legs.
        <br/><br/>
        And Cooling your feet.
        <br/><br/><br/>
        And before you take
        that deep
        breath
        again.
        <br/><br/>
        Notice how empty
        Your body feels...
        <br/><br/>
        Without the river.
</div>
  <div class="column" >   
        <h2>
          Wet Cloud
          <br/>A poem.
        </h2><br/>
        A wet cloud <br/>
means that We<br/>
Talk about<br/>
The smell<br/>
Of rain.<br/><br/><br/>

Down Pour<br/>
Is the looming<br/>
Reminder that<br/>
Your loved ones<br/>
Are wet <br/>
Too.<br/><br/><br/>


Maybe wet skin<br/>
Is not an unnecessary<br/>
Evil.<br/><br/><br/>

But <br/>
a Dry Shirt<br/>
Implies<br/>
That nothing <br/>
should cling <br/>
to your body.<br/><br/><br/>


When<br/>
It rains.<br/>
And smells<br/>
Of Rains.<br/>
And<br/><br/><br/>

The sky<br/>
Is a deep<br/>
Blue<br/>
Hue.<br/><br/><br/>

Know that<br/>
A wet cloud.<br/>
Was dry<br/>
With you<br/>
Too.
        <br/>
  </div>  </div>
  <div class="row">
  <div class="column" >   
    <img src="WetCloud2.jpg"></img>
  </div>
    <div class="column" >   
        <img src="WetCloud3.jpg"></img>
  </div>
</div>
    
    </div>

  );
}
